import { HTMLProps } from 'react'
import { Container, Spinner } from './styles'
import { useTour } from '../../../../../contexts'

export type SimpleButtonProps = HTMLProps<HTMLButtonElement> & {
  bg?: string;
  color?: string;
  onAction?: () => void;
  hasAnimation?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
}

export type IButtonConfig = {
  text: string;
  bg: string;
  color: string;
  disabled?: boolean;
}

export const initialButtonConfig = {
  text: 'Iniciar Game',
  bg: 'linear-gradient(180deg, #5AFF5A 0%, #70EE70 51.67%, #52C852 100%)',
  color: '#000'
}

const SimpleButton = ({ children, disabled, color, bg, onAction, hasAnimation = false, isLoading = false }: SimpleButtonProps) => {
  const { tourWasCompleted, currentStep } = useTour()

  return (
    <Container
      onClick={isLoading ? () => {} : onAction}
      color={color}
      bg={bg}
      $hasAnimation={hasAnimation}
      disabled={disabled}
      className={
        (currentStep.className === 'tourApproval-3' && !tourWasCompleted
          ? 'tourApproval-3 '
          : ''
        )}
    >
      { !isLoading ? children : <Spinner color={color} /> }
    </Container>
  )
}

export { SimpleButton }
